import { render } from "./AddDetachement.vue?vue&type=template&id=21a29e60&scoped=true&ts=true"
import script from "./AddDetachement.vue?vue&type=script&lang=ts"
export * from "./AddDetachement.vue?vue&type=script&lang=ts"

import "./AddDetachement.vue?vue&type=style&index=0&id=21a29e60&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a29e60"]])

export default __exports__